/**
 * Bill edit route — mounts the rich `BillComposerPage` in edit mode by
 * threading `loadBillId` through. Wrapped in `WorkspaceShell` so the page
 * gets the same scroll viewport + top-bar breadcrumbs as `/procurement/bills/new`
 * (without the shell, the composer lands in the layout's `overflow-hidden`
 * frame with no `ScrollArea`, so its `min-h-full` form + `sticky top-0`
 * head have nothing to scroll within — see issue #136). The composer
 * handles hydration, lifecycle gating (draft/review only), and the
 * `bills.update` save path.
 *
 * @see apps/web/src/features/bills/new/bill-composer-page.tsx
 * @see apps/web/src/routes/(workspace)/bills/new.tsx (the parallel new-bill route)
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.js";
import { BillComposerPage } from "../../../../features/bills/new/index.js";

export const Route = createFileRoute("/(workspace)/procurement/bills/$billId/edit")({
  component: BillEditRoute,
});

function BillEditRoute() {
  const { billId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Procurement", to: "/" },
        { label: "Bills", to: "/procurement/bills" },
        { label: "Edit" },
      ]}
      contentClassName="max-w-none"
      // Kill default ScrollArea viewport padding at *both* breakpoints. The
      // default is `p-5 md:p-6`; `p-0` alone only overrides the base — the
      // responsive `md:p-6` still wins ≥ md, leaving a 24px gutter above
      // the sticky composer-head that visually wraps it in a card.
      viewportClassName="p-0 md:p-0"
    >
      <BillComposerPage loadBillId={billId} />
    </WorkspaceShell>
  );
}
